import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  envType = environment.environmentType
  tradeName = '';
  constructor(private router: Router) { }

  ngOnInit() {
    if(this.envType == 'n') {
      this.tradeName = 'Nightlife Television';
    } else if (this.envType == 'm') {
      this.tradeName = 'MusicLand';
    } else if (this.envType == 'd') {
      this.tradeName = 'Nightlife';
    } else if (this.envType == 'h') {
      this.tradeName = 'Hollywood Highlights';
    } else {
      this.tradeName =  '';
    }
  }

  menuclick(menu: any): void {
    this.router.navigate(['/', menu]);
  }


}
